import MUIDataTable from "mui-datatables";

import { useTranslation } from "react-i18next";
import { getColumns, getOptions } from "./config";

const Table = ({ data, groupId }) => {
	const { t } = useTranslation();

	const columns = getColumns(t);
	const options = getOptions(t);

	return (
		<MUIDataTable
			className="mui-data-table group-table"
			data={data}
			columns={columns}
			options={{ ...options, groupId }}
		/>
	);
};

export default Table;
